(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DigitalMarketing.ActOn",
                    {
                        url: "/ActOn",
                        component: "actOn",
                        redirectTo: "Home.Tools.MarketingTrackerNew.DigitalMarketing.ActOn.ActOnCampaignList"
                    });
        }
    ]);

    app.component("actOn",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/DigitalMarketing/ActOn/act-on-template.html",
            controller: actOnController,
            bindings: {
            }
        });

    actOnController.$inject = [];
    function actOnController() {
        var $ctrl = this;        
    }

})(window.app, window.angular); //jshint ignore:line